import { computed, ref } from 'vue'
import api from '@/utils/ky'

const countries = ref([
  {
    name: '🇷🇺 Россия',
    code: 'ru',
    langs: [
      {
        name: 'Русский',
        code: 'ru'
      }
    ]
  },
  {
    name: '🇬🇧 Великобритания',
    code: 'gb',
    langs: [
      {
        name: 'Английский',
        code: 'en'
      }
    ]
  },
  {
    name: '🇮🇱 Израиль',
    code: 'il',
    langs: [
      {
        name: 'Русский',
        code: 'ru'
      },
      {
        name: 'Иврит',
        code: 'he'
      },
      {
        name: 'Английский',
        code: 'en'
      }
    ]
  },
  {
    name: '🇫🇷 Франция',
    code: 'fr',
    langs: [
      {
        name: 'Французский',
        code: 'fr'
      },
      {
        name: 'Английский',
        code: 'en'
      },
      {
        name: 'Испанский',
        code: 'es'
      }
    ]
  },
  {
    name: '🇪🇸 Испания',
    code: 'es',
    langs: [
      {
        name: 'Испанский',
        code: 'es'
      },
      {
        name: 'Английский',
        code: 'en'
      }
    ]
  }
])

export function useCountries ({ activeCountry } = {}) {
  const langs = computed(
    () =>
      (
        countries.value.find(country => country.code === activeCountry.value) ??
        {}
      ).langs ?? []
  )

  return {
    countries,
    langs
  }
}
